import { IProject } from '../../components/Geosupport/GetProjects';

export const getProject = (optionNumber: string, projects?: IProject[]) =>
  projects?.find((project) => optionNumber.toLowerCase().includes(project.swNumber.toLowerCase()));

export const getProjectYear = (optionNumber: string, projects?: IProject[]) => {
  const project = getProject(optionNumber, projects);
  return project?.createdDateTime?.getFullYear();
}